export const back = (timeFraction: number, n = 2) => {
    return Math.pow(timeFraction, 2) * ((n + 1) * timeFraction - n);
};
